import type { ReactNode } from 'react';
import { Link } from 'react-router';

/** Router link for the overview patterns' rows and numbers, which only take a wrap function */
export const linkTo = (to: string) => (content: ReactNode, className: string) => (
  <Link to={to} className={className}>
    {content}
  </Link>
);
